import React, { Fragment, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
  Button,
  TextField,
} from "@material-ui/core";

// Contexts
import ParameterContext from "../../context/parameters/ParameterContext";
import LayoutContext from "../../context/layout/LayoutContext";
import UserContext from "../../context/users/UserContext";

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  buttonBox: {
    textAlign: "right",
  },
  button: {
    textTransform: "none",
  },
}));

const UserCreation = () => {
  const classes = useStyles();

  const { user_group, getUserGroup } = useContext(ParameterContext);
  const { setAlert } = useContext(LayoutContext);
  const { register, new_account, user_error, clearErrors } =
    useContext(UserContext);

  const [submitted, setSubmitted] = useState(false);

  const user_details = {
    name: "",
    email: "",
    password: "",
    userGroup: "admin",
  };
  const [user, setUser] = useState(user_details);
  const { name, email, password, userGroup } = user;

  const backToUserList = () => {
    window.location.replace("/user");
  };

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (name === "" || email === "" || password === "" || userGroup === "") {
      setAlert("Please enter all fields.", "error");
    } else {
      const validEmailRegex =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      const pw_strength = {
        0: password.match(/[A-Z]/),
        1: password.match(/[a-z]/),
        2: password.match(/\d/),
        3: password.match(/[!@#\$%\^\&*\)\(+=._-]/),
      };

      let sum = 0;

      for (let x in pw_strength) {
        sum += pw_strength[x] ? 1 : 0;
      }

      if (!validEmailRegex.test(email)) {
        setAlert("Please include a valid email.", "error");
      } else if (password.length < 6) {
        setAlert("Please enter a password with 6 or more characters.", "error");
      } else if (sum < 3) {
        setAlert("Please enter a stronger password.", "error");
      } else {
        setSubmitted(true);
        register({
          name,
          email,
          password,
          user_group: userGroup,
        });
      }
    }
  };

  useEffect(() => {
    if (new_account && new_account.name) {
      setSubmitted(false);
      setAlert(`New account created for ${new_account.name}.`, "success");
      backToUserList();
    }
  }, [new_account]);

  useEffect(() => {
    if (user_error === "User already exists.") {
      setSubmitted(false);
      setAlert(user_error, "error");
      clearErrors();
    }
  }, [user_error]);

  useEffect(() => {
    getUserGroup();
  }, []);

  return (
    user_group && (
      <Fragment>
        {" "}
        {/* Header */}{" "}
        <Grid container spacing={1} className={classes.section}>
          <Grid
            container
            spacing={0}
            justifyContent="flex-start"
            className={classes.section}
          >
            <Grid item xs={12}>
              <Typography variant="h4"> User </Typography>{" "}
            </Grid>{" "}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" href="/user">
                  User{" "}
                </Link>{" "}
                <Link color="inherit"> Create </Link>{" "}
              </Breadcrumbs>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
        {/* Form */}{" "}
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          className={classes.section}
        >
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <form noValidate onSubmit={onSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    <TextField
                      required
                      fullWidth
                      variant="outlined"
                      size="small"
                      margin="dense"
                      id="name"
                      name="name"
                      label="Name"
                      autoComplete="name"
                      autoFocus
                      value={name}
                      onChange={onChange}
                    />{" "}
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      required
                      fullWidth
                      variant="outlined"
                      size="small"
                      margin="dense"
                      id="email"
                      name="email"
                      label="Email"
                      autoComplete="email"
                      value={email}
                      onChange={onChange}
                    />{" "}
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      required
                      fullWidth
                      variant="outlined"
                      size="small"
                      margin="dense"
                      type="password"
                      id="password"
                      name="password"
                      label="Password"
                      value={password}
                      onChange={onChange}
                      helperText={
                        <span>
                          The password should be at least 6 characters long.To
                          make it stronger, use upper or lower case letters,
                          numbers, and symbols like!@# $ % ^ & amp;*+ = ._ - .{" "}
                        </span>
                      }
                    />{" "}
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      required
                      fullWidth
                      select
                      SelectProps={{
                        native: true,
                      }}
                      variant="outlined"
                      size="small"
                      margin="dense"
                      id="userGroup"
                      name="userGroup"
                      label="User Group"
                      value={userGroup}
                      onChange={onChange}
                    >
                      {" "}
                      {user_group.map((each) => {
                        return (
                          <option key={each.user_group} value={each.user_group}>
                            {" "}
                            {each.user_group_name}{" "}
                          </option>
                        );
                      })}{" "}
                    </TextField>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </form>{" "}
            </Paper>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item xs={12} className={classes.buttonBox}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            disabled={submitted}
            onClick={onSubmit}
          >
            Save{" "}
          </Button>{" "}
          & emsp;{" "}
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            disabled={submitted}
            onClick={backToUserList}
          >
            Cancel{" "}
          </Button>{" "}
        </Grid>{" "}
      </Fragment>
    )
  );
};

export default UserCreation;
